import React, { useState } from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Task } from 'constants/interfaces'
import colors from 'constants/colors'
import useLocaleText from 'components/useLocaleText'
import { OwnerTaskListItem } from './OwnerTaskListItem'

interface IProps {
  tasks: Task[]
  onTaskClick?: (task: Task) => void
}

const COLLAPSED_COUNT = 3

export const OwnerTasksSection: React.FC<IProps> = ({ tasks, onTaskClick }) => {
  const [expanded, setExpanded] = useState(false)
  const see_more = useLocaleText('see_more_sidebar')
  const see_less = useLocaleText('see_less_sidebar')

  const visibleTasks = expanded ? tasks : tasks.slice(0, COLLAPSED_COUNT)
  const hasMore = tasks.length > COLLAPSED_COUNT

  return (
    <Box>
      {visibleTasks.map((task) => (
        <OwnerTaskListItem key={task.tid} task={task} onClick={onTaskClick} />
      ))}
      {hasMore && (
        <Flex
          as="button"
          alignItems="center"
          justifyContent="center"
          width="100%"
          py="6px"
          color={colors.greyDark2}
          fontSize="12px"
          fontWeight="bold"
          style={{ columnGap: 4, cursor: 'pointer' }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <Text>{expanded ? see_less : see_more}</Text>
          {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </Flex>
      )}
    </Box>
  )
}
